var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowRight = function SvgArrowRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M14.53 4.47a.75.75 0 1 0-1.06 1.06l5.72 5.72H3a.75.75 0 0 0 0 1.5h16.19l-5.72 5.72a.75.75 0 1 0 1.06 1.06l7-7a.75.75 0 0 0 0-1.06z",
    clipRule: "evenodd"
  })));
};
export default SvgArrowRight;